import { BillGroupDunningStatusEnum } from '@monetize/types/app';
import { FilterTypeOperator } from '@monetize/types/common';
import { objectToObjArray } from '../utils/misc';

export const BILL_GROUP_DUNNING_STATUS_DISPLAY: {
  [key in BillGroupDunningStatusEnum]: string;
} = {
  GOOD_STANDING: 'Good Standing',
  IN_DUNNING: 'In Dunning',
  PAUSED: 'Paused',
};

export const DUNNING_STATUS_FILTER_ITEMS = objectToObjArray(
  BILL_GROUP_DUNNING_STATUS_DISPLAY,
  'value',
  'label',
);

export const DUNNING_STATUS_FILTER_OPTION = {
  title: 'Dunning Status',
  key: 'dunningStatus',
  operator: FilterTypeOperator.IN,
  items: DUNNING_STATUS_FILTER_ITEMS,
};
